import React, { useState, useEffect } from"react";
import { useNavigate } from"react-router-dom";
import Editor from"@monaco-editor/react";
import axios from"axios";

const HuntLevel3 = () => {
 const [code, setCode] = useState("");
 const [output, setOutput] = useState("");
 const [startTime] = useState(Date.now());
 const [elapsedTime, setElapsedTime] = useState(0);
 const [showClue, setShowClue] = useState(false);

 const navigate = useNavigate();

 useEffect(() => {
 const timer = setInterval(() => {
 setElapsedTime(Math.floor((Date.now() - startTime) / 1000));
 }, 1000);
 return () => clearInterval(timer);
 }, [startTime]);

 const handleSubmit = async () => {
 try {
 const response = await axios.post("http://localhost:5000/api/hunt/submit/3", { code });
 if (response.data.success) {
 setOutput(response.data.message);
 setShowClue(true);
 } else {
 setOutput(response.data.message);
 }
 } catch (err) {
 setOutput("Server error.");
 }
 };

 return (
 <div className="min-h-screen bg-bgMain text-gold p-8">
 <h1 className="text-3xl font-bold mb-4">Level 3: The Ledger Discrepancy</h1>
 <p className="mb-6 text-white">
 Something doesn’t add up in this ledger.
 <br />
 Compare the sign-outs. One entry is missing a name.
 </p>

 <img
 src="/clues/clue2.png"
 alt="Checkout Slip Clue"
 className="w-full mb-6 max-h-[60vh] object-contain rounded shadow-lg"
 />

 <div className="mb-2 text-sm text-muted">⏱ Time Elapsed: {elapsedTime}s</div>

 <div className="bg-[#1e1e1e] rounded-md mb-4">
 <Editor
 height="300px"
 defaultLanguage="javascript"
 theme="vs-dark"
 value={code}
 onChange={(value) => setCode(value)}
 />
 </div>

 <button
 onClick={handleSubmit}
 className="mt-4 bg-primary text-white px-6 py-2 rounded-md hover:bg-secondary transition"
 >
 Submit Code
 </button>

 <div className="mt-4 bg-[#111] p-4 rounded-md">
 <h3 className="text-white font-semibold">Output:</h3>
 <pre className="text-green-400 whitespace-pre-wrap">{output}</pre>
 </div>

 {showClue && (
 <div className="mt-6">
 <h2 className="text-xl font-bold mb-2 text-white">🧩 Clue Unlocked!</h2>
 <img
 src="/clues/clue3.png"
 alt="Final Clue"
 className="w-full h-screen object-contain rounded-lg border border-gold shadow-lg transition-all duration-700 ease-in-out"
 />
 <button
 onClick={() => navigate("/hunt/final")}
 className="mt-4 bg-green-600 text-white px-4 py-2 rounded-md"
 >
 Proceed to Final Hunt
 </button>
 </div>
 )}
 </div>
 );
};

export default HuntLevel3;



